export type PromoTag = {
  label: string;
};

type PromoTagPascal = { Label: string };
type PromoTagLowerSnake = { label: string };

const PROMOS_TO_HIDE: Array<string> = [];

export const getPromoTags = (promoTags?: Array<PromoTagPascal | PromoTagLowerSnake> | null): Array<PromoTag> | null => {
  if (!promoTags) return [];

  return promoTags
    .map((tag: any) => {
      return {
        label: ('label' in tag ? tag.label : tag.Label) as string,
      };
    })
    .filter((tag: any) => !PROMOS_TO_HIDE.includes(tag.label));
};
